import React from "react";
import TablaGruposSKU from "js/pages/Unilever/Campana/GruposSKU/Tabla";

function GruposSKU(props) {
  return <TablaGruposSKU />;
}

export default GruposSKU;
